// extracted by mini-css-extract-plugin
export var news = "news-module--news--G42-V";
export var news__btn = "news-module--news__btn--21q5C";
export var news__category = "news-module--news__category--1GmJW";
export var news__smalltext = "news-module--news__smalltext--3CeU_";
export var news__date = "news-module--news__date--1NjUq";
export var news__newsbtn = "news-module--news__newsbtn--1FO7Y";